import $ from 'jquery'

export default {
    name: 'assure-examens',
    components: {},
    props: {
        list_exclu_examens: Array
    },
    data() {
        return {
            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_EXAMEN', this.one_is_checked)
        }
    },

    computed: {
        types_examens() {
            return this.$store.getters["examens"];
        },
    },

    mounted() {
        this.listExamens()
    },

    methods: {
        clearSelected() {
            this.one_is_checked = []
            this.all_checked = false

            this.types_examens.forEach((type_examen) => {
                this.text_grey[type_examen.id] = ''
            });
        },

        setSelectedExamens() {
            this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_examens.forEach(exclusion => {
                this.types_examens.forEach(type_examen => {
                    if (exclusion.id == type_examen.id) {
                        this.text_grey[type_examen.id] = 'text-grey'
                        this.one_is_checked.push(type_examen.id)
                    }
                });
            });
        },

        listExamens() {
            this.$store.dispatch("getExamens").then(() => {
                if (this.types_examens.length > 0) {
                    this.clearSelected()

                    setTimeout(() => {
                        this.setSelectedExamens()
                    }, 1000);
                }
            })
        },

        toutSelectionner() {
            let is_checked = $('#examen-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.types_examens.forEach((type_examen) => {
                    this.text_grey[type_examen.id] = 'text-grey'

                    this.one_is_checked.push(type_examen.id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                this.types_examens.forEach((type_examen) => {
                    this.text_grey[type_examen.id] = ''
                });
            }
        },

        onExclu(index) {
            let is_checked = $('#exm'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("examen-tous").checked = false;
        },
    }
}